<div class="content-wrapper table-full-bx usersTable">
    <div class="page-content recruiterpanel">
        <div class="row">
            <!-- Active users -->
            <div class="col-lg-12">
                <div class="ibox">
                   
                    <div class="ibox-body">

                        <div class="iboxcontent mt-4 pb-2">
                            <h3> Users </h3>
                         </div>
                        <!-- tabs -->
                        <ul class="nav nav-pills job-list mt-0">
                            <li class="active">
                                <a href="javascript:void(0)" routerLink="/users">Active Users</a>
                            </li>
                            <li>
                                <a href="javascript:void(0)" routerLink="/archived">Archived Users</a>
                            </li>
                        </ul>
                        <!-- searchbox -->
                        <div class="flexbox">

                            <div class="iboxcontent">
                                
                             </div>
                           
                            <div class="input-group-icon input-group-icon-left">
                                <div class="col-list-right">
                                    <form (ngSubmit)="searchFun()">
                                        <div class="form-group">
                                            <span class="input-icon input-icon-right font-16" (click)="searchFun()"><img src="assets/images/search.svg"></span>
                                            <input type="text" [(ngModel)]="search" autocomplete="off" class="form-control form-control-rounded form-control-solid search" name="search" id="key-search" placeholder="Search Name, Email, Phone Number, Group" />
                                            <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span>
                                        </div>
                                    </form>
                                </div>

                                <div class="col-list-right">
                                    <a routerLink="/users/add" class="commonBtn2"><img src="assets/images/ic_add_project.svg" class="ap" /> Add User </a>
                                </div>
                            </div>
                        </div>
                        <!-- end -->
                        <!-- Table -->
                        <div class="table-scroll table-wrapper user-top table-responsive">
                            <table id="example" class="table table-bordered table-hover" style="width: 100%;">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th class="emailSec">Recruiter</th>
                                        <th class="emailSec">Email ID </th>
                                        <th class="minWidth">Phone number </th>
                                        <!-- <th>Last activity </th> -->
                                        <th class="action">Jobs </th>
                                        <th class="minWidth">Group </th>
                                        <th class="action">Action </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- 1 -->
                                    <tr *ngFor="let data of activeUsersData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                                        <td><a [routerLink]="'detail/' + data?.id">{{data?.newId}}</a></td>
                                        <td class="td-linked"> 
                                            <a [routerLink]="'detail/' + data?.id" class="linkedIn">
                                                <span class="text-orange">{{data?.fullName}}</span> 
                                                <i class="icons"><img (click)="goToLinkedInUrl(data?.linkedin)" *ngIf="data?.linkedin" src="assets/images/ic_linkedin-logo.svg" /></i>
                                            </a>
                                        </td>
                                        <td><a [routerLink]="'detail/' + data?.id" style="text-transform: lowercase">{{data?.email}} </a></td>
                                        <td><a [routerLink]="'detail/' + data?.id">{{data?.phoneNumber | mask:'0000-000-000'}}</a></td>
                                        <!-- <td><a [routerLink]="'detail/' + data?.id">{{data?.lastActivity | date: "d/M/YYYY h:mm a"}}</a></td> -->
                                        <td><a (click)="redirectToJobs(data)"><span class="text-orange">{{data?.recruiterJobs}}</span></a></td>
                                        <td class="actionWrap"><a [routerLink]="'detail/' + data?.id"> 
                                                <span *ngFor="let group of data?.assign_user_groups;let isLast=last">
                                                    {{group?.group_permission?.groupName}} {{ isLast ? "" : ", " }}
                                                </span>
                                            </a>
                                        </td>
                                        <td>
                                            <div ngbDropdown>
                                                <a class="nav-link dropdown-toggle link" data-toggle="dropdown" aria-expanded="false" id="dropdown_profile_area" ngbDropdownToggle> 
                                                    <img src="assets/images/ic_three_dot.svg" />
                                                </a>
                                                <div class="dropdown-menu">
                                                    <ul ngbDropdownMenu>
                                                        <li><a class="dropdown-item" [routerLink]="'edit/' + data?.id">Edit</a></li>
                                                        <li><a class="dropdown-item" (click)="updateStatus(data?.id,data?.isArchive)">Archive</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="noDataFound" *ngIf="activeUsersData.length == 0">
                                <h2>No Records Found</h2>
                            </div>
                        </div>
                        <!-- end -->
                        <!--  pagination  -->
                        <div class="col-sm-12 p-0" *ngIf="totalCount > 9">
                            <ul class="pagination ">
                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                            </ul>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>